module.exports = __webpack_public_path__ + "media/src/images/logos/helpscout-a4fef048085c21e71903bebb9c2b4fa9.png";